<template>
  <div>
    <v-select
      v-bind="$attrs"
      v-on="$listeners"
      :items="items"
      item-value="text"
      item-text="text"
      item-disabled="disabled"
      :return-object="false"
      multiple
      :data-testid="dataTestid"
    >
      <template v-slot:selection="{ item }">
        <v-chip small :close="!readonly" @click:close="onClear(item)">
          <span>{{ item.text }}</span>
        </v-chip>
      </template>
    </v-select>
    <v-dialog v-model="modal" max-width="500">
      <v-card>
        <v-card-title>Impossible de supprimer ce domaine</v-card-title>
        <v-card-text>
          Un ou plusieurs thèmes actuellement sélectionnés sont liés à ce domaine.
          Veuillez les supprimer avant de supprimer ce domaine.
        </v-card-text>
        <v-card-actions>
          <v-btn ref="non" color="primary" @click="modal = false">Ok</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { domaines, themesDuDomaine } from "./domaine";

function uniq(a) {
  var seen = new Set();
  return a.filter(function (item) {
    if (seen.has(item)) {
      return false;
    }
    seen.add(item);
    return true;
  });
}

export default {
  inject: ["form"],
  props: {
    "data-testid": {
      type: String,
      required: false,
    },
    theme: {
      type: Array,
      required: false,
    },
    anciens: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      modal: false,
      domaines: [...domaines.map(d => d.text)],
    };
  },

  computed: {
    readonly() {
      return this.form?.readonly;
    },
    items() {
      const values = this.$attrs.value ? [...this.$attrs.value] : [];
      return uniq([...this.anciens, ...values, ...this.domaines]).map(d => {
        const themesDomaine = themesDuDomaine([d]);
        const estSelectionne = values.includes(d);
        const disabled = !!(
          this.theme?.some(theme => themesDomaine.includes(theme)) && estSelectionne
        );
        return { text: d, disabled };
      });
    },
  },

  methods: {
    onClear(ev) {
      if (ev?.disabled === false) {
        let value = [...this.$attrs.value];
        value.splice(value.indexOf(ev.text), 1);
        this.$emit("input", value);
      } else {
        this.modal = true;
      }
    },
  },
};
</script>
